import { initializeApp, getApps } from 'firebase/app';
import { getAnalytics, logEvent, isSupported, setUserId } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyD5Z_NgyyQ-qkhh3c-ditWUXFAW7ZI7DWY',
  authDomain: 'marsresume-ca261.firebaseapp.com',
  projectId: 'marsresume-ca261',
  storageBucket: 'marsresume-ca261.firebasestorage.app',
  messagingSenderId: '230969248309',
  appId: '1:230969248309:web:40d13eb06704b52885ff7c',
  measurementId: 'G-XD7BDJNRP0',
};

let analytics = null;

// Call this once the user has consented to analytics cookies.
// Safe to call multiple times — idempotent.
export const enableAnalytics = async () => {
  if (analytics) return;
  try {
    const ok = await isSupported();
    if (!ok) return;
    const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
    analytics = getAnalytics(app);
  } catch (e) {
    console.warn('Firebase Analytics init failed:', e.message);
  }
};

// Check saved consent on startup and enable analytics if already accepted.
export const bootstrapAnalytics = () => {
  try {
    const saved = localStorage.getItem('mars_cookie_consent');
    if (!saved) return;
    const { analytics: analyticsConsent } = JSON.parse(saved);
    if (analyticsConsent) enableAnalytics();
  } catch {}
};

// Analytics must never break the app — every call is wrapped.
export const track = (eventName, params = {}) => {
  try { if (analytics) logEvent(analytics, eventName, params); } catch {}
};

export const trackPageView = (path) => {
  track('page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const identifyUser = (userId) => {
  try { if (analytics && userId) setUserId(analytics, String(userId)); } catch {}
};
